export default __webpack_public_path__ + "static/media/IMG_2334.f5d38059.jpg";